export default __webpack_public_path__ + "static/media/CapacityShortfall_Page_Banner-new.a8a246f5.jpg";